(() => {
  'use strict';

  const ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
  const REVISION = '2026-07-15';

  function setMessage(element, visible) {
    if (element) {
      element.hidden = !visible;
    }
  }

  function bindNewsletterForm(form) {
    if (form.dataset.klaviyoNewsletterBound === 'true') {
      return;
    }

    const config = form.querySelector('[data-klaviyo-newsletter-config]');
    const emailInput = form.querySelector('input[type="email"]');
    const submitButton = form.querySelector('button[type="submit"]');
    const successMessage = form.querySelector('[data-klaviyo-newsletter-success]');
    const errorMessage = form.querySelector('[data-klaviyo-newsletter-error]');
    const companyId = config?.dataset.companyId?.trim();
    const listId = config?.dataset.listId?.trim();

    if (!companyId || !listId || !emailInput || !submitButton) {
      return;
    }

    form.dataset.klaviyoNewsletterBound = 'true';

    // Capture-Phase: läuft garantiert vor Shopifys hCaptcha-Listener, den Shopify beim ersten Fokus
    // direkt am Formular registriert. Der würde das (dann geleerte) Formular sonst klassisch an
    // /contact schicken: Seite lädt neu und zeigt „E-Mail darf nicht leer sein“.
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (!form.reportValidity()) {
        return;
      }

      const email = emailInput.value.trim();
      setMessage(successMessage, false);
      setMessage(errorMessage, false);
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Shopify Footer Newsletter',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      };

      try {
        const response = await fetch(`${ENDPOINT}?company_id=${encodeURIComponent(companyId)}`, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          headers: {
            accept: 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json',
            revision: REVISION
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Newsletter subscription request failed');
        }

        emailInput.value = '';
        setMessage(successMessage, true);
      } catch (_error) {
        setMessage(errorMessage, true);
      } finally {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      }
    }, true);
  }

  function initNewsletterForms(root = document) {
    root.querySelectorAll('form[data-klaviyo-newsletter]').forEach(bindNewsletterForm);
  }

  initNewsletterForms();
  document.addEventListener('shopify:section:load', (event) => initNewsletterForms(event.target));
})();
